import React, { ReactElement } from 'react';
import { ServerSideInitProps } from 'types/types';
import { PersonBaseInterface } from 'components/interfaces/PersonInterface';
import CoachPage from 'components/pages/coach/detail/CoachPage';
import {
    CoachClubListItemApiInterface,
    CoachDetailApiInterface,
} from 'submodules/api_middleware';
import { ConfigPageInterface } from 'utils/helpers/server/serverSideProps/config';
import { getData } from 'utils/helpers/server/serverSideData';
import { Config_CoachDetail_ApiInterface } from 'submodules/api_middleware/src/interfaces/config/CoachDetailConfigApiInterface';
import { getGlobalProps } from 'utils/helpers/server/serverSideProps/global';
import { getPageProps } from 'utils/helpers/server/serverSideProps/ssrProps';
import { getPageNamespaces } from 'utils/helpers/server/serverSideProps/translations';
import { buildCoachPersonBase } from 'utils/helpers/server/serverSideProps/coachPersonBase';
import { buildCoachDetailConfigStub } from 'utils/helpers/server/serverSideProps/coachConfig';
import {
    isCoachesRequestAllowed,
    isCoachesPublicRequest,
} from 'utils/helpers/server/coachesAccess';
import { serverRedirect } from 'utils/helpers/server/serverRedirect';

interface Props extends ConfigPageInterface<Config_CoachDetail_ApiInterface> {
    personBase: PersonBaseInterface;
    coach: CoachDetailApiInterface;
    clubs: CoachClubListItemApiInterface[];
}

interface ServerSideProps {
    props?: Props;
    notFound?: boolean;
}

const Page = ({ personBase, config, coach, clubs }: Props): ReactElement => (
    <CoachPage
        personBase={personBase}
        config={config}
        coach={coach}
        clubs={clubs}
    />
);

export const getServerSideProps = async ({
    req,
    res,
    query,
}: ServerSideInitProps): Promise<ServerSideProps> => {
    // TODO: po otestování na produkci smazat – na public hostu povolit i nepřihlášené.
    const { api, discipline } = await getGlobalProps(
        req,
        res,
        isCoachesPublicRequest(req)
    );

    // TODO: tento if po otestování na produkci Smazat.
    if (!isCoachesRequestAllowed(req, res)) {
        serverRedirect('/home', res);
        return {};
    }

    const publishId = String(query.id ?? '');
    if (!publishId) {
        return { notFound: true };
    }

    const coachRaw: CoachDetailApiInterface = await getData(
        res,
        req,
        api.coach().coachDetail(publishId)
    );
    if (!coachRaw) {
        return { notFound: true };
    }

    const { personBase, coach } = buildCoachPersonBase(coachRaw, discipline);
    const config = buildCoachDetailConfigStub();

    // Career history (Is1TrenerOddil) is rendered inline below the licences
    // table on the Osobní údaje page rather than on a dedicated subpage. A
    // single coach rarely has more than a handful of club rows, so we ask the
    // BE for one large page and skip the paginator UI entirely.
    const clubsResponse = await getData(
        res,
        req,
        api.coach().coachClubs(publishId, { page_size: 100 })
    );

    const props = await getPageProps<Props>({
        givenProps: {
            coach,
            config,
            personBase,
            clubs: clubsResponse?.data ?? [],
        },
        req,
        res,
        api,
        query,
        nameSpaces: getPageNamespaces('/coaches/{0}'),
    });

    return { props };
};

export default Page;
